export const I18N_LOCALE_ROOT =
  "settings.billing.plans.trial_opt_in_modal" as const;
